import { useNavigate } from "react-router-dom"

import Style from "./style"
import check from "./asset/check.svg"
import checked from "./asset/checked.svg"

import MainHeader from "widget/MainHeader"
import Pagenation from "widget/Pagenation"

import useGetAdvertiseList from "entity/advertise/useGetAdvertiseList"
import usePutAdvertiseActive from "entity/advertise/usePostAdvertiseActive"
import useDeleteAdvertiseActive from "entity/advertise/useDeleteAdvertiseActive"

import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"
import TableLoading from "shared/ui/TableLoading"

const AdList = () => {
    const navigate = useNavigate()

    const [advertiseList, isLoading] = useGetAdvertiseList()
    const [activeAdvertise] = usePutAdvertiseActive()
    const [deactiveAdvertise] = useDeleteAdvertiseActive()

    const btnList = [
        {
            "label": "생성",
            "clickEvent": () => navigate("/ad/create"),
            "deactive": false
        }
    ]
    const sizeList = ["short", "longlonglong", "expand", "short", "long"]
    const tableHeadList = ["IDX", "배너 이미지", "연결 링크", "활성", "생성 날짜"]

    const changeActiveStateEvent = (e, state, idx) => {
        e.stopPropagation()
        state
            ? deactiveAdvertise(idx)
            : activeAdvertise(idx)
    }

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList}>광고 목록</MainHeader>

            <TableLoading isLoading={isLoading}>
                <TStyle.TableDiv>
                    <TStyle.TableInner>
                        <TStyle.TableRow $title>
                            {tableHeadList.map((elem, index) =>
                                <TStyle.Data key={index} $title $size={sizeList[index]}>{elem}</TStyle.Data>
                            )}
                        </TStyle.TableRow>
                        {advertiseList?.data?.advertise_list?.map((elem, index) =>
                            <TStyle.TableRow key={index} $odd={index % 2 === 1} $exapnd onClick={() => navigate(`/ad/${elem?.idx}/detail`)}>
                                <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                                <TStyle.Data $size={sizeList[1]}>
                                    <Style.PreviewImg src={elem?.banner_img} />
                                </TStyle.Data>
                                <TStyle.Data $size={sizeList[2]}>{elem?.url}</TStyle.Data>
                                <TStyle.Data $size={sizeList[3]}>
                                    <Style.Radio onClick={(e) => changeActiveStateEvent(e, elem?.is_active, elem?.idx)}><img src={elem?.is_active ? checked : check} /></Style.Radio>
                                </TStyle.Data>
                                <TStyle.Data $size={sizeList[4]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                            </TStyle.TableRow>
                        )}
                    </TStyle.TableInner>
                </TStyle.TableDiv>
            </TableLoading>

            <Pagenation maxPage={advertiseList?.data?.max_page} />
        </Style.Wrapper>
    )
}

export default AdList